export const photographers = [
    "Angela Thompson",
    "Christopher Goldsack",
    "Maggie Berry",
    "Nathan Comben",
    "Peter Chamberlain",
    "Ann Beauchamp",
    "Richard Escott",
    "Vicki Portanier",
    "Sonia Bonkat",
    "Bevil Templeton-Smith",
];


// WEBPACK FOOTER //
// ./src/data/photographers.js